import { render, staticRenderFns } from "./right-selector.vue?vue&type=template&id=810a9448&scoped=true"
import script from "./right-selector.vue?vue&type=script&lang=js"
export * from "./right-selector.vue?vue&type=script&lang=js"
import style0 from "./right-selector.vue?vue&type=style&index=0&id=810a9448&prod&lang=less"
import style1 from "./right-selector.vue?vue&type=style&index=1&id=810a9448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810a9448",
  null
  
)

export default component.exports